/**
 * Friendly copy for authentication failures.
 *
 * Users never see a Firebase error code (Implementation Guide §28). The
 * raw error is still returned so development builds can show it in the
 * ErrorState detail block.
 */

const MESSAGES = {
  "auth/popup-closed-by-user":
    "Looks like the sign-in window closed. No problem: try again, or keep playing as a guest.",
  "auth/cancelled-popup-request":
    "That sign-in was cancelled. Try again when you're ready.",
  "auth/popup-blocked":
    "Your browser blocked the sign-in window. Allow pop-ups for this site and try again.",
  "auth/network-request-failed":
    "We couldn't reach the network. Check your connection and try again.",
  "auth/too-many-requests":
    "Too many attempts just now. Give it a minute and try again.",
  "auth/operation-not-allowed":
    "This sign-in method isn't switched on yet. Continuing as a guest works fine in the meantime.",
  "auth/unauthorized-domain":
    "This site isn't authorised for sign-in yet. Continuing as a guest works fine in the meantime.",
  "auth/credential-already-in-use":
    "That Google account is already linked to another profile. We signed you into that one instead.",
  "auth/admin-restricted-operation":
    "Guest mode isn't switched on for this project yet.",
};

const FALLBACK =
  "We couldn't sign you in just then. You can try again, or keep going as a guest.";

export function friendlyAuthError(error) {
  if (!error) return FALLBACK;
  return MESSAGES[error.code] ?? FALLBACK;
}
